import { SEO_PAGE_MIN_RESULTS } from '@core/Constants/Search';
import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';

export type FilterOptionLinkDisplay = 'display' | 'omit' | 'no-follow';

const MAX_EXTRA_FACETS_PER_URL = {
  new: 0,
  'lease-deals': 1,
  used: 2,
};

/**
 * Contains the business logic to determine if a filter option
 * should display a link or not.
 * See tests for specific rules.
 */
export const shouldDisplayFilterOptionLink = ({
  resultCount,
  isSelected,
  categoryHasOptionSelected,
  numExtraFacetsWithActiveFilters,
  root,
}: {
  /**
   * Whether the filter category has _some_ option selected.
   * doesn't have to be the current option.
   */
  categoryHasOptionSelected: boolean;
  numExtraFacetsWithActiveFilters: number;
  root: PlpRoot;
} & (
  | {
      /**
       * Whether the filter option is currently selected in the filter list
       */
      isSelected: boolean;
      /**
       * Number of results that enabling the filter option will return.
       * Will be ignored if the option is already selected, hence is optional
       */
      resultCount: number;
    }
  | {
      isSelected: true;
      resultCount?: undefined;
    }
)): FilterOptionLinkDisplay => {
  if (
    (!isSelected && resultCount === 0) ||
    numExtraFacetsWithActiveFilters > MAX_EXTRA_FACETS_PER_URL[root] ||
    (categoryHasOptionSelected && !isSelected)
  )
    return 'omit';

  if (!isSelected && resultCount < SEO_PAGE_MIN_RESULTS) return 'no-follow';

  return 'display';
};
